<script>
import LocaleButton from '@components/locale-button'
import NotificationBar from '@views/notifications'

export default {
  components: { LocaleButton, NotificationBar },
}
</script>

<template>
  <v-app id="simple">
    <v-toolbar
      flat
    >
      <v-toolbar-title 
        style="cursor: pointer" 
        @click="$router.push('/')">XEVEL</v-toolbar-title>
      <v-spacer />
      <locale-button />
    </v-toolbar>
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg2
          >
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <notification-bar/>
  </v-app>
</template>

<style lang="scss" module>
@import '@design';
</style>
